module.exports = __webpack_public_path__ + "img/tab-info.f8ddd0ba.svg";